import '../style/App.css';
import React from 'react';
import PlusNav from './PlusNav';

function App() {
  return (
    <div className="App">
      <PlusNav />
    </div>
  );
}

export default App;
